import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import ReactTable from "react-table";
import FormattedDateValue from '../../fields/dates/FormattedDate';
import FormattedCurrencyValue from '../../fields/number/FormattedCurrencyValue';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ReactComponentHelper from '../../helper/ReactComponentHelper';
import Pagination from '../../page/Pagination';
import NoData from '../../page/NoData';
import ApplicationMessages from '../../inAppMessages/ApplicationMessages';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../../utils/logger';
import _ from 'underscore';
import FilterPanel from './FilterPanel';
import SaveFilingToWorkflow from '../SaveFilingToWorkflow';
import VAT_RETURN_BY_TRANSACTIONS_CONTROLLER, { generateCustomCsvFilename } from '../../../controllers/vatReturnByTransactions';
import { withFullStoryExclude } from '../../../utils/fullStoryHelper';
import ExportAll from '../../common/ExportAll';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import FILING_CONTROLLER from "../../../controllers/filing";
import getClientConfig from '../../../utils/getClientConfig';
import { FeatureFlagEnum } from '../../../utils/enums';

const log = new Logger('VAT_RETURN_BY_TRANSACTIONS', LOG_LEVELS.DEBUG);

class ReturnByTransactions extends Component {

  constructor(props) {
    super(props);
    this.doFilterHandler = this.doFilterHandler.bind(this);
    this.getDataByGetTransactions = this.getDataByGetTransactions.bind(this);
    this.pagedDataFetch = this.pagedDataFetch.bind(this);
    this.getLanguageText = this.getLanguageText.bind(this);
    this.handleExportAllTransactions = this.handleExportAllTransactions.bind(this);
    this.onDownloadTransactionsCsvClick = this.onDownloadTransactionsCsvClick.bind(this);
    this.onSaveToWorkflowClick = this.onSaveToWorkflowClick.bind(this);

    this.state = {
      visible: false,
      page: 0,
      pages: undefined,
      pageSize: 20,
      selection: {},
      loading: false,
      transactionType: 0
    };
  }

  getLanguageText(languages, key) {
    return this.props.showToast && languages && LANGUAGES_CONTROLLER.formatUtilFormatter(languages.data, key);
  }

  handleExportAllTransactions() {
    const params = {
      tenantId: this.props.customerId,
      companyId: this.props.companyId,
      countryCode: this.props.countryCode,
      periodStartDate: this.props.startDate,
      periodEndDate: this.props.endDate,
      frequency: this.determineFrequencyId(this.state.selection || {}),
      transactionType: this.state.transactionType,
      userName: this.props.userName
    }
    this.props.doExportTransactions(params);
  }

  onDownloadTransactionsCsvClick() {
    let selection = this.state.selection;

    this.props.doDownloadTransactionsCsv({
      companyId: this.props.companyId,
      companyCode: this.props.companyCode,
      companyName: this.props.companyName,
      countryCode: this.props.countryCode,
      startDate: this.props.startDate,
      endDate: this.props.endDate,
      frequency: this.determineFrequencyId(selection),
      transactionType: this.determineTransactionTypeId(selection),
      transactionTypeName: selection.transactionType || 'sales',
      fixedAssets: selection.fixedAssets === '1',
      page: this.state.page +1,
      lines: this.state.pageSize,
      dataFormat: 'CSV',
      returnDisplayType: this.props.returnDisplayType
    });
  }

  onSaveToWorkflowClick = (submissionType) => {
    let selection = this.state.selection;
    
    // Generate fileName using the required format
    const fileName = generateCustomCsvFilename({
      transactionTypeName: selection.transactionType || 'sales',
      countryCode: this.props.countryCode,
      frequency: this.determineFrequencyId(selection),
      startDate: this.props.startDate,
      companyName: this.props.companyName,
      companyCode: this.props.companyCode,
      returnDisplayType: this.props.returnDisplayType
    });
    
    this.props.onSaveToWorkflow({
      companyId: this.props.companyId,
      userName: this.props.userName ? this.props.userName : "Unknown",
      tenantId: this.props.customerId ? this.props.customerId : null,
      countryCode: this.props.countryCode,
      periodStartDate: this.props.startDate,
      periodEndDate: this.props.endDate,
      frequency: this.determineFrequencyId(selection),
      transactionType: this.determineTransactionTypeId(selection),
      totalCount: this.props.returnByTransactionsData?.totalTransactionCountInReport,
      isCorrective: submissionType === "corrective" ? true : false,
      jurisdiction: this.props.countryCode,
      vatReportingCode: this.props.companyCode,
      filterType: 'CSV',
      fileName: fileName
    }, (error, _response) => {
      if (error) {
        log.setDictionaryMessage(ALL_MESSAGES.SAVE_TO_WORKFLOW_FAIL);
      }
      else {
        log.setDictionaryMessage(ALL_MESSAGES.SAVE_TO_WORKFLOW_OK);
      }
    });
  }


  getPages() {
    let rows, pageCount = 0;

    if (this.props.returnByTransactionsData !== undefined) {
      rows = this.props.returnByTransactionsData.totalTransactionCountInReport || 0;
      pageCount = Math.ceil(rows / this.state.pageSize);
    }
    log.debug('getPages(): pageCount: ', pageCount);
    return pageCount;
  }

  doFilterHandler(selection) {
    log.debug("doFilterHandler: calling this.getDataByGetTransactions with selection:", selection);

    // Setting page to 0 to reset the table back to the first page of results when applying a filter
    this.setState({ selection: selection, page: 0, pages: undefined });

    this.getDataByGetTransactions('1', this.state.pageSize, selection);

  }

  getColumns(companyCode, totalValue, totalValueExclVAT, totalValueVAT) {
    let filterable = false;

    const transactionColumns = [{
      id: 'invoiceDate',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_invoiceDate'} />),
      accessor: data => <FormattedDateValue value={data.invoiceDate} format='dd-mm-yyyy' />,
      filterable: filterable
    }, {
      // Link to Transaction Search using Invoice Number
      Header: props => (<LanguageStringResolver string={'returnByTransactions_invoiceNumber'} />),
      accessor: 'invoiceNumber',
      filterable: filterable,
      Cell: ({ row }) => {
        //redirect to TransactionSearch page
        let linkToUrl = '/TransactionSearch?companyCode=' + companyCode + '&exactMatch=1&reference=' + row['invoiceNumber'] + '&searchType=0';
        let linkComponent = (<Link to={linkToUrl}>{row['invoiceNumber']}</Link>)
        return (
          <div>
            {linkComponent}
          </div>
        );
      }
    }, {
      Header: props => (
        (this.state.transactionType === 0 || this.state.transactionType === 2 ?
          <LanguageStringResolver string={'returnByTransactions_partner_sales'} /> :
          <LanguageStringResolver string={'returnByTransactions_partner_purchases'} />)
      ),
      accessor: 'partner',
      filterable: filterable
    }, {
      Header: props => (
        (this.state.transactionType === 0 || this.state.transactionType === 2 ?
          <LanguageStringResolver string={'returnByTransactions_partnerCountry_sales'} /> :
          <LanguageStringResolver string={'returnByTransactions_partnerCountry_purchases'} />)
      ),
      accessor: 'partnerCountry',
      filterable: filterable
    }, {
      // Link to VIES check modal
      Header: props => (
        (this.state.transactionType === 0 || this.state.transactionType === 2 ?
          <LanguageStringResolver string={'returnByTransactions_partnerVATNumber_sales'} /> :
          <LanguageStringResolver string={'returnByTransactions_partnerVATNumber_purchases'} />)
      ),
      accessor: 'partnerVATNumber',
      minWidth: 150,
      filterable: filterable,
      // Cell: ({ row }) => {
      //   let linkToVATNumber = '/do/a/modal?vatNumber=' + row['partnerVATNumber'];
      //   let linkVATNumberCheck = (<Link to={linkToVATNumber}>{row['partnerVATNumber']}</Link>);
      //   return (
      //     <div>
      //       {linkVATNumberCheck}
      //     </div>
      //   );
      // }
    }, {
      id: 'total',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_total'} />),
      accessor: 'total',
      Footer: this.state.page + 1 === this.state.pages ?
        <span>
          {totalValue}
        </span>
        : null,
      ...ReactComponentHelper.getCurrencyColumnOptions({ isSensitive: true }),
      filterable: filterable
    }, {
      id: 'taxableBasis',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_taxableBasis'} />),
      accessor: 'taxableBasis',
      Footer: this.state.page + 1 === this.state.pages ?
        <span>
          {totalValueExclVAT}
        </span>
        : null,
      ...ReactComponentHelper.getCurrencyColumnOptions({ isSensitive: true }),
      filterable: filterable
    }, {
      id: 'vat',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_vat'} />),
      accessor: 'vat',
      Footer: this.state.page + 1 === this.state.pages ?
        <span>
          {totalValueVAT}
        </span>
        : null,
      ...ReactComponentHelper.getCurrencyColumnOptions({ isSensitive: true }),
      filterable: filterable
    }, {
      Header: props => (<LanguageStringResolver string={'returnByTransactions_vatCodeUsed'} />),
      accessor: 'vatCodeUsed',
      filterable: filterable,
      className: withFullStoryExclude()
    }, {
      id: 'transactionDate',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_transactionDate'} />),
      accessor: data => <FormattedDateValue value={data.transactionDate} format='dd-mm-yyyy' />,
      filterable: filterable
    }, {
      id: 'originalTransactionDate',
      Header: props => (<LanguageStringResolver string={'returnByTransactions_originalTransactionDate'} />),
      accessor: data => <FormattedDateValue value={data.originalTransactionDate} format='dd-mm-yyyy' />,
      filterable: filterable
    }];

    return transactionColumns
  }

  render() {
    log.debug('render(): ', this.props);

    const { featureFlags } = getClientConfig();
    const disableCurrentTransactions = featureFlags?.[FeatureFlagEnum.DISABLE_EXPORT_VAT_CURRENT_TRANSACTIONS];
    const returnByTransactionsData = this.props.returnByTransactionsData || {};
    let transactionsData = (this.props.returnByTransactionsData && this.props.returnByTransactionsData.transactions) || [];
    let columns = (this.props.returnByTransactionsData && this.buildDynamicColumns(returnByTransactionsData.totals.boxes)) || [];

    const NoDataComponent = props => (
      <NoData
        noDataText="returnByTransactions_noData"
        {...props}
      />
    );

    return (
      <div className="content-area">
        <FilterPanel
          availablePeriods={this.props.frequencyOptions || []}
          onSearch={this.doFilterHandler.bind(this)}
          defaultFrequencyId={this.props.frequency}
        />
        <ReactTable
          data={transactionsData}
          minRows={0}
          maxRows={0}
          defaultPageSize={this.props.lines || 100}
          pages={this.state.pages}
          pageSizeOptions={[20, 50, 100, 1000]}
          columns={columns}
          manual
          onFetchData={this.pagedDataFetch}
          Footer={false}
          PaginationComponent={Pagination}
          showPagination={transactionsData.length === 0 ? false : true}
          NoDataComponent={NoDataComponent}
          showPageJump={false}
          loading={this.state.loading}
          sortable={false}
        />

        {!disableCurrentTransactions &&
          <button
            data-testid="export-current"
            className={transactionsData && transactionsData.length > 0 ? "mt-2 secondary" : "invisible"}
            onClick={this.onDownloadTransactionsCsvClick}
          >
            <LanguageStringResolver string='global_ExportCurrentTableAsCSV' />
          </button>
        }

        {transactionsData && transactionsData.length > 0 &&
          <ExportAll
            exportLabel='global_export_all'
            testId="export-all"
            exportClick={() => this.handleExportAllTransactions()}
            exportFor='ENABLE_EXPORT_VAT_RETURN_TRANSACTIONS'
            showToast={true}
            elementType='btn'
            toastTitle={this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastTitle')}
            toastDetails={this.getLanguageText(this.props.languages, 'viewTransmission_ExportAllToastDetails')}
          />
        }
        {transactionsData && transactionsData.length > 0 && this.props.canUserSaveToWorkflow &&
          <SaveFilingToWorkflow onSaveToWorkflow={this.onSaveToWorkflowClick} className='margin-top-md margin-left-md' />
        }
        <div>
          <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.SAVE_TO_WORKFLOW_FAIL]} />
          <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.SAVE_TO_WORKFLOW_OK]} />
        </div>
      </div>
    )
  }

  pagedDataFetch(state) {
    let { page, pageSize, pages, selection, sorted, filtered } = state;
    const userPageIndex = page + 1;
    pageSize = Object.is(pageSize, NaN) ? 20 : pageSize;
    page = Object.is(page, NaN) ? 0 : page;
    this.setState({
      page: page,
      pageSize: pageSize,
      loading: true,
      sorted: sorted,
      filtered: filtered
    });

    log.debug("pagedDataFetch: pageNumber: %s linesPerPage: %s pages: %s", userPageIndex, pageSize, pages);
    log.debug("pagedDataFetch selection: ", selection);

    this.getDataByGetTransactions(userPageIndex, pageSize, selection).then(
      ((returnedPageCount) => {
        log.debug("pagedDataFetch setting this.state.page to pageCount: ", returnedPageCount);
        this.setState({
          pages: returnedPageCount,
          loading: false
        })
      })
    )
  }


  buildDynamicColumns(totalsBoxes) {
    // The VAT Box columns are dynamic based on API Response so here we add them to the column
    // definition before passing the column definition json to react-table
    //
    // We use the totals element of the response as this has a value per box, so this is our
    // non-repeating set of columns we need to add.
    //
    // Then we create a react-table definition and concat that with the static set of columns
    // defined in getColumns(); returning the static + dynamic as part of the render()
    //

    let columnDefinitionsForBoxes = [];
    const companyCode = this.props.companyCode;
    let columns = this.getColumns(
      companyCode,
      <FormattedCurrencyValue value={this.props.returnByTransactionsData.totals.totalValue} inputFieldClassName={withFullStoryExclude()} />,
      <FormattedCurrencyValue value={this.props.returnByTransactionsData.totals.totalValueExclVAT} inputFieldClassName={withFullStoryExclude()} />,
      <FormattedCurrencyValue value={this.props.returnByTransactionsData.totals.totalValueVAT} inputFieldClassName={withFullStoryExclude()} />
    );

    _.sortBy(totalsBoxes, 'name').forEach(item => {
      columnDefinitionsForBoxes.push({
        Header: <span>Box {item.name}</span>,
        accessor: "flatboxes." + item.name,
        className: withFullStoryExclude('text-align-right'),
        filterable: false,
        Footer: () => {
          if (this.state.page + 1 === this.state.pages) {
            if (this.props.returnByTransactionsData) {
              return (
                <span>
                  {this.props.returnByTransactionsData.totals.flatBoxes[item.name]}
                </span>
              );
            }
          }
        }
      });
    });

    log.debug('buildDynamicColumns: Column definitions for dynamic VAT Box columns', columnDefinitionsForBoxes);
    return columns.concat(columnDefinitionsForBoxes)
  }

  getDataByGetTransactions(startAt, lines, selection) {
    if (!selection) { selection = Object.assign({}, this.state.selection) }
    log.debug("getDataByGetTransactions startAt %s, lines %s , selection %s, props:", startAt, lines, selection, this.props);
    return new Promise((resolve, reject) => {

      // SVR-3931 add it to state so the columns can by dynamic based on type
      this.setState({ transactionType: this.determineTransactionTypeId(selection) });

      this.props.getTransactions(
        {
          companyId: this.props.companyId,
          countryCode: this.props.countryCode,
          startDate: this.props.startDate,
          endDate: this.props.endDate,
          frequency: this.determineFrequencyId(selection),
          returnDisplayType: this.props.returnDisplayType,
          transactionType: this.determineTransactionTypeId(selection),
          page: startAt,
          lines: lines,
          dataFormat: "JSON"
        }).then(
          (() => {
            let pageCount = this.getPages();
            resolve(pageCount);
          })
        )
    })
  }

  /**
   * Abstracted the logic to massage the transactionType
   * @param {object} selection
   * @returns {number}
   */
  determineTransactionTypeId(selection) {
    log.debug("determineTransactionTypeId: ", selection);

    let transactionTypeId;

    switch (selection.transactionType) {
      case 'purchases':
        transactionTypeId = 1;
        break;
      case 'sales':
        transactionTypeId = 0;
        break;
      default:
        transactionTypeId = 0;
    }

    if (selection.fixedAssets === '1') { transactionTypeId = transactionTypeId + 2 }

    return transactionTypeId;
  }

  /**
   * Abastracted the logic for choosing the frequency as it can be set at page props or overridden on filter panel
   * @param selection
   * @returns {number}
   */
  determineFrequencyId(selection) {
    log.debug("determineFrequencyId: ", selection);

    let frequencyId;
    (selection.frequency ? frequencyId = selection.frequency : frequencyId = this.props.frequency);

    return frequencyId;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let pageCount;
    if (this.props.returnByTransactionsData !== undefined) {
      pageCount = this.getPages()
      if (this.state.pages !== pageCount) {
        this.setState({ pages: pageCount })
      }
    }
    if (this.props.returnDisplayType !== prevProps.returnDisplayType) {
      this.doFilterHandler(this.state.selection);
    }
  }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
  log.debug('mapStateToProps: ', state);
  return {
    languages: state.languages,
    returnByTransactionsData: state.filingTransactions && state.filingTransactions.data,
    showToast: state.filing?.showToast,
    canUserSaveToWorkflow: state.filing?.canUserSaveToWorkflow,
    customerId: state.authentication && state.authentication.data && state.authentication.data.customerId,
    userName: (state.authentication && state.authentication.data && state.authentication.data.userName) || "Unknown",
  }
}

function mapDispatchToProps(dispatch) {
  return {
    getTransactions: (params) => {
      log.debug('getTransactions mapDispatchToProps: ', params)
      return new Promise((resolve) => {
        dispatch(VAT_RETURN_BY_TRANSACTIONS_CONTROLLER.doLoad(params))
        resolve()
      })
    },
    doExportTransactions: (params) => {
      dispatch(FILING_CONTROLLER.doExportTransactions(params));
    },
    doDownloadTransactionsCsv: (params) => {
      log.debug('doDownloadTransactionsCsv mapDispatchToProps:', params);
      dispatch(VAT_RETURN_BY_TRANSACTIONS_CONTROLLER.doDownloadTransactionsCsv(params));
    },
    onSaveToWorkflow: (params, callback) => {
      log.debug('onSaveToWorkflow mapDispatchToProps:', params);
      dispatch(VAT_RETURN_BY_TRANSACTIONS_CONTROLLER.doSaveToWorkflow(params, callback));
    }
  }
}


ReturnByTransactions.defaultProps = {
  companyCode: '',
  transactionType: 0,  // Sales
  lines: 20,
  page: 1,
  frequencyOptions: []
};

// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps, mapDispatchToProps)(ReturnByTransactions);
